var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6756 10.6215L20.2329 3H18.6789L12.9856 9.618L8.4376 3H3.1936L10.0704 13.0072L3.1936 21H4.7476L10.7596 14.0115L15.5626 21H20.8074L13.6756 10.6215ZM11.5479 13.0958L10.8504 12.099L5.3086 4.17H7.6951L12.1681 10.569L12.8656 11.5658L18.6804 19.8832H16.2939L11.5479 13.0958Z",
    fill: "#A93AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.cb317da979e3f70d204a663653612bd9.svg";
export { ForwardRef as ReactComponent };